import { render, staticRenderFns } from "./baja-temporal.vue?vue&type=template&id=ee6e395e&scoped=true&"
import script from "./baja-temporal.vue?vue&type=script&lang=js&"
export * from "./baja-temporal.vue?vue&type=script&lang=js&"
import style0 from "./baja-temporal.vue?vue&type=style&index=0&id=ee6e395e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6e395e",
  null
  
)

export default component.exports